"use client";
import { useEffect } from "react";
import { projectURL } from "../components/lib/site";

// Sends a path or query on endur.io to the project's own subdomain,
// keeping the query string (?ref=…) and hash.
const ProjectRedirect = ({ project }: { project: string }) => {
  useEffect(() => {
    const { search, hash } = window.location;
    window.location.replace(projectURL(project, search + hash));
  }, [project]);
  return null;
};

export default ProjectRedirect;
